import { withStyles } from '@material-ui/core';
import DriverRecommendationsPanel from './DriverRecommendationsPanel';
const styles = (theme) => ({
  container: {
    minWidth: 463,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    borderLeft: `1px solid ${theme.AppBGColor}`,
    position: 'relative',
    boxShadow: '1px 1px 4px'
  }
});
const DriverRecommendationsPanelContainer = ({ classes, ...others }) => {
  return (
    <div className={`${classes.container}`}>
      <DriverRecommendationsPanel {...others} />
    </div>
  );
};

export default withStyles(styles)(DriverRecommendationsPanelContainer);
